export const name = 'presetDetailsController';
export default function presetDetailsController($q, presetsService, $stateParams, impositionTemplatesService,
                                                $log, $mdDialog, $state, $scope, $timeout, $document, $translate, rnPusher, fileDownloaderFactory,
                                                errorDialogOpen, pusherChannel, closeDialogFromOutsideHelperFactory) {
  //noinspection BadExpressionStatementJS
  'ngInject';

  let vm = this;
  vm.presetId = $stateParams.presetId;
  vm.preset = $stateParams.preset;
  vm.mode = $stateParams.mode; // Modes - [update, new, duplicate]
  vm.mode = vm.mode ? vm.mode : 'update';
  let iconsRequire = require.context('@printos/imposer-ui/src/components/templates/images/icons', false, /\.svg/);
  vm.warningIcon = iconsRequire('./warning.svg');
  vm.infoIcon = iconsRequire('./Info.svg');
  vm.caretIcon = iconsRequire('./caret.svg');
  vm.defaultIcon = iconsRequire("./star_checked.svg");
  vm.nonDefaultIcon = iconsRequire("./star_unchecked.svg");
  vm.lockIcon = iconsRequire("./lock.svg");
  vm.isPdfPresetDetailsVisible = false;
  vm.closeUploadDialog = closeDialogFromOutsideHelperFactory.createCloseDialogFromOutsideHelperObject();
  vm.pdfCompatibility = ['1.5', '1.6', '1.7'];
  vm.renderingIntents = ['AbsuluteColorImetric', 'Perceptual', 'RelativeColorImetric', 'Saturation', 'Auto'];
  vm.channelName = null;
  vm.pdfPresetDuplicateDisabled = false;
  // Add missingAssetOptions for md-select
  vm.missingAssetOptions = [
    { value: 'Fail', label: 'imposer.composer-main.preset_fail' },
    { value: 'Warning', label: 'imposer.composer-main.preset_warning' }
  ];
  vm.pdfPresetUpload = {
    resetUploadDirective: false,
    showProgress: false,
    knownProgress: false,
    uploadProgress: uploadProgressCallback,
    onFileSelected: onFileSelect
  };

  function registerEvents() {
    let defer = $q.defer();
    pusherChannel.getChannelName().then(channelName => {
      vm.channelName = channelName;
      let promises = [];
      promises.push(rnPusher.bind(channelName, "PDF_PRESET_LIST_ENTRY_ADDED", onPdfPresetEntryAdded));
      promises.push(rnPusher.bind(channelName, "PDF_PRESET_LIST_ENTRY_CHANGED", onPdfPresetEntryChanged));
      promises.push(rnPusher.bind(channelName, "PDF_PRESET_LIST_ENTRY_DELETED", onPdfPresetEntryDeleted));
      promises.push(rnPusher.bind(channelName, "PRESET_LIST_ENTRY_CHANGED", onPresetEntryChanged));
      promises.push(rnPusher.bind(channelName, "PRESET_ENTRY_PDF_PRESET_UNLINK", onPresetEntryPdfPresetUnlink));
      promises.push(rnPusher.bind(channelName, "IMPP_LIST_ENTRY_ADDED", onIMPPEntryAdded));
      promises.push(rnPusher.bind(channelName, "IMPP_LIST_ENTRY_DELETED", onIMPPEntryDeleted));

      $q.all(promises).then(() => {
        defer.resolve();
      });
    });

    return defer.promise;
  }

  (function activate() {
    registerEvents();
    if (vm.preset) {
      //Fetch PDF presets
      getPdfPresets().then(pdfPresets => {
        updateFields(pdfPresets);
      });
    } else {
      if (vm.presetId) {
        //Fetch preset
        presetsService.getPreset(vm.presetId).then(preset => {
          if (preset.sameNameIndex > 0) {
            preset.name = preset.name + '-' + preset.sameNameIndex;
          }
          vm.preset = preset;

          if (preset.predefined) {
            $translate.onReady(() => {
              vm.preset.name = $translate.instant('imposer.composer-main.' + preset.name);
            });
          }

          //Fetch PDF presets
          getPdfPresets().then(pdfPresets => {
            updateFields(pdfPresets);
          });
        }, error => {
          console.log(error);
        });
        console.log(vm.preset);
      }
    }
  })();

  function updateFields(pdfPresets) {
    vm.impositionSelection = new impositionTemplatesService.ImpositionSelection(isCustomDistributionRequired());

    vm.preset.splitToValue = vm.preset.splitTo > 0 ? vm.preset.splitTo : 3;
    vm.preset.useExternalImposition = vm.preset.impositionId > 0;
    vm.preset.skipRecords = vm.preset.skipRows !== -1;
    vm.preset.skipRowsAutomatically = vm.preset.skipRows <= 0;
    vm.preset.splitEnabled = vm.preset.splitTo > 1;
    vm.impositionSelection.setDefaultImpositionTemplate(null, null, vm.preset.impositionId, null);

    if (pdfPresets) {
      vm.richPdfPresets = pdfPresets.listOfElements.filter(curr => curr.type === 'Rich');
      vm.fastPdfPresets = pdfPresets.listOfElements.filter(curr => curr.type === 'Fast');
      vm.selectedRichPdfPreset = angular.copy(vm.richPdfPresets.filter(curr => curr.id === vm.preset.richPdfPresetId)[0]);
      vm.selectedFastPdfPreset = angular.copy(vm.fastPdfPresets.filter(curr => curr.id === vm.preset.fastPdfPresetId)[0]);
    }
    updatePdfPresetFields();
    vm.originalPresetValues = angular.copy(vm.preset);
    vm.originalPresetValues.predefined = false;
    vm.originalPdfPresetValues = angular.copy(vm.selectedFastPdfPreset);

    if (vm.preset.predefined && vm.mode === 'update') {
      $('.fast-pdf-preset-details .settings').show();
    } else {
      if (vm.mode === 'new') {
        vm.preset.name = '';
        $translate.onReady(function () {
          vm.originalPresetValues.name = $translate.instant('imposer.composer-main.preset_new');
        });
      }
      if (vm.preset.predefined) {
        vm.preset.predefined = false;
      }
    }
  }

  function isCustomDistributionRequired(){
    return vm.preset.preferredMode === 'Fast' && vm.preset.splitType === 'Chunks';
  }

  function updatePdfPresetFields() {
    vm.selectedFastPdfPreset.isCustomBleed = vm.selectedFastPdfPreset.bleedSize > -1;
    vm.selectedFastPdfPreset.bleedSizeForDisplay = vm.selectedFastPdfPreset.isCustomBleed ? vm.selectedFastPdfPreset.bleedSize : 0;
    vm.selectedFastPdfPreset.downsampleVariableImages = vm.selectedFastPdfPreset.downsampleVariableImageDPI > 0;
  }

  function getPdfPresets() {
    let defer = $q.defer();
    presetsService.getPdfPresets().then(pdfPresets => {
      console.log(pdfPresets);
      defer.resolve(pdfPresets);
    }, error => {
      console.log(error);
      defer.reject(error);
    });
    return defer.promise;
  }

  vm.switchSelectedPreferredType = function (preferredMode) {
    if (vm.preset.preferredMode !== preferredMode) {
      vm.preset.preferredMode = preferredMode;
      if (vm.preset.preferredMode === 'Rich'){
        vm.impositionSelection.removeCustomDistributionImpositions();
        vm.vdpPresetForm.$setDirty(true);
        if (vm.impositionSelection && vm.impositionSelection.selectedImpositionTemplate.distributionAreaEnabled) {

          $mdDialog.show({
            parent: angular.element(document.body),
            targetEvent: event,
            clickOutsideToClose: false,
            escapeToClose: true,
            template: require('@printos/imposer-ui/src/components/common/confirm-dialog/confirmDialog.html'),
            controller: 'confirmDialogController',
            bindToController: true,
            controllerAs: 'vm',
            locals: {
              title: 'imposer.composer-main.Composer_Status_Warning',
              confirmMessage: $translate.instant('imposer.composer-main.custom_distribution_not_supported_rich'),
            }
          }).then(function () {
            vm.impositionSelection.setDefaultImpositionTemplate(false);
            vm.vdpPresetForm.impositionTemplate.$setDirty(true);
          }, error => {
            vm.preset.preferredMode = 'Fast';
            vm.vdpPresetForm.$setDirty(false);
            vm.impositionSelection.restoreCustomDistributionImpositions(isCustomDistributionRequired());
          });
        }
      }else{
        vm.impositionSelection.restoreCustomDistributionImpositions(isCustomDistributionRequired());
        vm.vdpPresetForm.$setDirty(true);
      }
    }
  };

  vm.switchSplitType = function (splitType) {
    if (vm.preset.splitType !== splitType) {
      vm.preset.splitType = splitType;
      if (vm.preset.splitType === 'Records') {
        vm.impositionSelection.removeCustomDistributionImpositions();
        vm.vdpPresetForm.$setDirty(true);
        if (vm.impositionSelection && vm.impositionSelection.selectedImpositionTemplate.distributionAreaEnabled) {
          $mdDialog.show({
            parent: angular.element(document.body),
            targetEvent: event,
            clickOutsideToClose: false,
            escapeToClose: true,
            template: require('@printos/imposer-ui/src/components/common/confirm-dialog/confirmDialog.html'),
            controller: 'confirmDialogController',
            bindToController: true,
            controllerAs: 'vm',
            locals: {
              title: 'imposer.composer-main.Composer_Status_Warning',
              confirmMessage: $translate.instant('imposer.composer-main.custom_distribution_not_supported_split_by_records_dialog'),
            }
          }).then(function () {
            vm.impositionSelection.setDefaultImpositionTemplate(false);
            vm.vdpPresetForm.impositionTemplate.$setDirty(true);
          }, error => {
            vm.preset.splitType = 'Chunks';
            vm.vdpPresetForm.$setDirty(false);
            vm.impositionSelection.restoreCustomDistributionImpositions(isCustomDistributionRequired());
          });
        }
      } else {
        vm.impositionSelection.restoreCustomDistributionImpositions(isCustomDistributionRequired());
        vm.vdpPresetForm.$setDirty(true);
      }
    }
  };

  vm.cancel = function () {
    vm.vdpPresetForm.$setPristine();
    vm.preset = angular.copy(vm.originalPresetValues);
    //vm.selectedFastPdfPreset = angular.copy(vm.originalPdfPresetValues);
  };

  vm.save = function ($event) {
    let presetValues = vm.vdpPresetForm.$$controls.reduce((obj, control) => {
      obj[control.$name] = control.$modelValue;
      return obj;
    }, {});

    presetValues.preferredMode = vm.preset.preferredMode;
    presetValues.splitType = vm.preset.splitType;

    if (presetValues.impositionTemplate) {
      presetValues.impositionId = presetValues.impositionTemplate.templateId;
      delete presetValues.impositionTemplate;
    }
    if (presetValues.useExternalImposition !== undefined && presetValues.useExternalImposition === false) {
      presetValues.impositionId = -1;
    }

    if (presetValues.skipRowsAutomatically) {
      presetValues.skipRows = 0;
    } else {
      presetValues.skipRows = 1;
    }

    if (presetValues.skipRecords !== undefined) {
      if (presetValues.skipRecords === true) {
        if (vm.preset.skipRowsAutomatically === true) {
          presetValues.skipRows = 0;
        } else {
          presetValues.skipRows = 1;
        }
      } else {
        presetValues.skipRows = -1;
        delete presetValues.skipRecords;
      }
    }

    if (presetValues.splitEnabled !== undefined && presetValues.splitEnabled === false) {
      presetValues.splitTo = -1;
      delete presetValues.splitEnabled;
    }

    $mdDialog.show({
      parent: angular.element(document.body),
      targetEvent: $event,
      clickOutsideToClose: false,
      escapeToClose: false,
      template: require('./save-dialog/save-dialog.html'),
      controller: 'saveDialogController',
      bindToController: true,
      controllerAs: 'vm',
      locals: {
        updatedValues: presetValues,
        saveFunction: presetsService.addPreset
      }
    }).then(function (newPreset) {
      if (newPreset) {
        vm.mode = 'update';
        if (newPreset.sameNameIndex > 0) {
          newPreset.name = newPreset.name + '-' + newPreset.sameNameIndex;
        }
        vm.preset = newPreset;
        updateFields();
      }
    }, function (error) {
      if (error) {
        errorDialogOpen.openErrorDialog(error);
      }
    });
    vm.vdpPresetForm.$setPristine();
  };

  vm.update = function ($event) {
    let dirtyFields = vm.vdpPresetForm.$$controls.filter(control => {
      return control.$dirty && control.$name !== 'vm.pdfPresetForm' && !control.$$attr.disabled;
    });

    let updatedValues = dirtyFields.reduce((obj, control) => {
      obj[control.$name] = control.$modelValue;
      return obj;
    }, {});

    updatedValues.id = vm.preset.id;

    if (vm.originalPresetValues.preferredMode !== vm.preset.preferredMode) {
      updatedValues.preferredMode = vm.preset.preferredMode;
    }
    if (vm.originalPresetValues.splitType !== vm.preset.splitType) {
      updatedValues.splitType = vm.preset.splitType;
    }
    if (updatedValues.impositionTemplate) {
      if(updatedValues.impositionTemplate.isNoImpositionEntry === true){
        updatedValues.applyImposition = false;
        updatedValues.impositionId = -1;
      }else{
        updatedValues.impositionId = updatedValues.impositionTemplate.templateId;
      }
      delete updatedValues.impositionTemplate;
    }
    if (updatedValues.useExternalImposition !== undefined && updatedValues.useExternalImposition === false) {
      updatedValues.impositionId = -1;
    }
    if (updatedValues.skipRecordsAutomatically) {
      updatedValues.skipRows = 0;
    } else {
      updatedValues.skipRows = 1;
    }
    if (updatedValues.skipRecords !== undefined) {
      if (updatedValues.skipRecords === true) {
        if (vm.preset.skipRowsAutomatically === true) {
          updatedValues.skipRows = 0;
        } else {
          updatedValues.skipRows = 1;
        }
      } else {
        updatedValues.skipRows = -1;
        delete updatedValues.skipRecords;
      }
    }
    if (updatedValues.splitEnabled !== undefined && updatedValues.splitEnabled === false) {
      updatedValues.splitTo = -1;
      delete updatedValues.splitEnabled;
    }else{
      updatedValues.splitTo = vm.preset.splitToValue;
    }

    let updatedPdfPresetValues;
    if (vm.pdfPresetForm.$dirty) {
      updatedPdfPresetValues = getPdfPresetUpdatedValues();
    }

    $mdDialog.show({
      parent: angular.element(document.body),
      targetEvent: $event,
      clickOutsideToClose: false,
      escapeToClose: false,
      template: require('./save-dialog/save-dialog.html'),
      controller: 'saveDialogController',
      bindToController: true,
      controllerAs: 'vm',
      locals: {
        updatedValues: updatedValues,
        updatedPdfPresetValues: updatedPdfPresetValues,
        saveFunction: updatePresetWithPdfPresets
      }
    });

    function updatePresetWithPdfPresets(preset, pdfPreset) {
      let defer = $q.defer();
      let promises = [];

      promises.push(presetsService.updatePreset(preset));
      if (pdfPreset) {
        promises.push(presetsService.updatePdfPreset(pdfPreset));
      }
      $q.all(promises).then(
        function () {
          promises[0].then(function (updatedPreset) {
            if (updatedPreset === undefined) {
              errorDialogOpen.openErrorDialog();
            } else {
              vm.vdpPresetForm.$setPristine();
              if (promises.length > 1) {
                promises[1].then(function (updatedPdfPreset) {
                  if (updatedPdfPreset === undefined) {
                    errorDialogOpen.openErrorDialog();
                  } else {
                    vm.pdfPresetForm.$setPristine();
                    defer.resolve(updatedPdfPreset);
                  }
                }, error => {
                  errorDialogOpen.openErrorDialog(error);
                  defer.reject(error);
                });
              } else {
                defer.resolve(updatedPreset);
              }
            }
          }, error => {
            errorDialogOpen.openErrorDialog(error);
            defer.reject(error);
          });
        }
      );
      return defer.promise;
    }
  };

  vm.updatePdfPreset = function ($event) {
    let updatedValues = getPdfPresetUpdatedValues();

    $mdDialog.show({
      parent: angular.element(document.body),
      targetEvent: $event,
      clickOutsideToClose: false,
      escapeToClose: false,
      template: require('./save-dialog/save-dialog.html'),
      controller: 'saveDialogController',
      bindToController: true,
      controllerAs: 'vm',
      locals: {
        updatedValues: updatedValues,
        saveFunction: presetsService.updatePdfPreset
      }
    }).then(function (updatedTemplate) {
      /*if(updatedTemplate) {
        vm.selectedFastPdfPreset = updatedTemplate;
        updatePdfPresetFields();
      }*/
    }, function (error) {
      if (error) {
        errorDialogOpen.openErrorDialog(error);
      }
    });
    vm.pdfPresetForm.$setPristine();
  };

  function getPdfPresetUpdatedValues() {
    let dirtyFields = vm.pdfPresetForm.$$controls.filter(control => {
      return control.$dirty && !control.$$attr.disabled;
    });

    let updatedValues = dirtyFields.reduce((obj, control) => {
      obj[control.$name] = control.$modelValue;
      return obj;
    }, {});

    updatedValues.id = vm.selectedFastPdfPreset.id;

    if (updatedValues.customBleed !== undefined && updatedValues.customBleed === false) {
      updatedValues.bleedSize = -1;
    } else {
      updatedValues.bleedSize = vm.selectedFastPdfPreset.bleedSizeForDisplay;
    }
    if (updatedValues.downsampleVariableImages !== undefined && updatedValues.downsampleVariableImages === false) {
      updatedValues.downsampleVariableImageDPI = 0;
    }

    return updatedValues;
  }

  vm.openImpositionEdit = function ($event) {
    if (!vm.impositionSelection.selectedImpositionTemplate.templateId) {
      return;
    }

    let stateArgs = {
      'presetId': vm.preset.id,
      'templateId': vm.impositionSelection.selectedImpositionTemplate.templateId
    };

    $state.transitionTo('presets.presetdetails.imposition', stateArgs);
    //switchToState(dataViewState, stateArgs);
  };

  function uploadProgressCallback(uploadReportPercentage, entityId = null) {
    if (entityId) {
      vm.entityId = entityId;
    }

    if (uploadReportPercentage) {
      vm.uploadProgress = uploadReportPercentage;
      vm.knownProgress = true;
      if (uploadReportPercentage === 100) {
        vm.knownProgress = false;
      }
      $scope.$apply();
    }
  }

  function onFileSelect($files, $event) {
    let fileSelected = $files[0];
    let functionName = 'presetDetailsController.onFileSelect';
    $log.info(angular.toJson({action: 'function called', functionName: functionName, fileName: fileSelected.name}));

    vm.pdfPresetUpload.fileSelected = fileSelected;
    vm.pdfPresetUpload.reset = false;
    vm.pdfPresetUpload.reset = true;
    $mdDialog.show({
      parent: angular.element(document.body),
      targetEvent: $event,
      clickOutsideToClose: false,
      escapeToClose: true,
      template: require('./../pdf-preset-upload-dialog/pdf-preset-upload.html'),
      controller: 'PdfPresetUploadController',
      bindToController: true,
      controllerAs: 'vm',
      locals: {
        closeDialogFromOutsideHelperObject: vm.closeUploadDialog,
        fileUploadProps: vm.pdfPresetUpload
      }
    }).then(function (pdfPreset) {
      $log.info(angular.toJson({
        action: 'dialog closed successfully',
        functionName: functionName,
        pdfPreset: pdfPreset
      }));
      vm.pdfPresetUpload.resetUploadDirective = !vm.pdfPresetUpload.resetUploadDirective;
      if (pdfPreset) {
        if (pdfPreset.type === 'Fast') {
          vm.preset.fastPdfPresetId = pdfPreset.id;
          vm.selectedFastPdfPreset = pdfPreset;
          updatePdfPresetFields();
          vm.isPdfPresetDetailsVisible = true;
          vm.vdpPresetForm.fastPdfPresetId.$setDirty(true);
        } else {
          vm.preset.richPdfPresetId = pdfPreset.id;
          vm.selectedRichPdfPreset = pdfPreset;
          vm.vdpPresetForm.richPdfPresetId.$setDirty(true);
        }
      }
      //vm.pdfPresetUpload.resetUploadDirective = !vm.pdfPresetUpload.resetUploadDirective;
    }, error => {
      vm.pdfPresetUpload.resetUploadDirective = !vm.pdfPresetUpload.resetUploadDirective;
    });

    $log.info(angular.toJson({action: 'function return', functionName: functionName}));
  }

  vm.deletePdfPreset = function (pdfPreset) {
    let functionName = 'presetDetailsController.delete';
    $log.info(angular.toJson({action: 'function called', functionName: functionName, pdfPreset: pdfPreset}));

    presetsService.getLinkedPresets(pdfPreset.id).then(listOfUsingPresets => {
      if (listOfUsingPresets) {
        if (listOfUsingPresets.length === 0) {
          openDeletionDialog();
        } else {
          openUnlinkPresetsDialog(pdfPreset, listOfUsingPresets).then(listOfUsingPresets => {
            if (listOfUsingPresets.length === 0) {
              openDeletionDialog();
            }
          }, error => {
            if (error) {
              errorDialogOpen.openErrorDialog(error);
            }
          });
        }
      }
    });

    function openDeletionDialog() {
      $mdDialog.show({
        parent: angular.element(document.body),
        targetEvent: event,
        clickOutsideToClose: false,
        escapeToClose: true,
        template: require('./../delete-presets/preset-delete.html'),
        controller: 'presetDeleteController',
        bindToController: true,
        controllerAs: 'vm',
        locals: {
          listOfElementToDelete: [pdfPreset.id],
          elementName: pdfPreset.name,
          deleteFunc: deletePdfPreset
        }
      }).then(function () {
        if (pdfPreset.type === 'Fast') {
          vm.selectedFastPdfPreset = vm.fastPdfPresets.filter(pdfPreset => pdfPreset.predefined)[0];
        } else if (pdfPreset.type === 'Rich') {
          vm.selectedRichPdfPreset = vm.richPdfPresets.filter(pdfPreset => pdfPreset.predefined)[0];
        }
        $log.info(angular.toJson({action: 'dialog closed successfully', functionName: functionName}));
      });
    }

    function openUnlinkPresetsDialog(pdfPreset, listOfUsingPresets) {
      let functionName = 'presetsController.openUnlinkPresetsDialog';
      $log.info(angular.toJson({action: 'function called', functionName: functionName, pdfPreset: pdfPreset}));

      let defer = $q.defer();

      let elementTypeName = $translate.instant('imposer.composer-main.pdf_presets');

      $mdDialog.show({
        parent: angular.element(document.body),
        targetEvent: event,
        clickOutsideToClose: false,
        escapeToClose: true,
        template: require('@printos/imposer-ui/src/components/common/usage-dialog/usage-dialog.html'),
        controller: 'usageDialogController',
        bindToController: true,
        controllerAs: 'vm',
        locals: {
          title: 'imposer.composer-main.pdf_preset_links',
          numberOfElements: 1,
          listOfLinkedElements: listOfUsingPresets,
          elementName: pdfPreset.name,
          isLocked: pdfPreset.default,
          elementTypeName: elementTypeName,
          linkedElementsTypeName: 'imposer.composer-main.presets',
          unlinkFunc: unlinkPresets,
          showElementFunc: showPresetDetails
        }
      }).then(function (data) {
        $log.info(angular.toJson({action: 'dialog closed successfully', functionName: functionName}));
        defer.resolve(data);
      }, error => {
        defer.reject(error);
      });

      function showPresetDetails(presetId) {
        $state.transitionTo('presets.presetdetails', {presetId: presetId});
      }

      function unlinkPresets(presetsIdsToUnlink) {
        let defer = $q.defer();
        presetsService.unlinkPresets(presetsIdsToUnlink, pdfPreset.type).then(response => {
          defer.resolve(response);
        }, error => {
          defer.reject(error);
        });
        return defer.promise;
      }

      return defer.promise;
    }

    $log.info(angular.toJson({action: 'function return', functionName: functionName}));
  };

  vm.exportPdfPreset = function (pdfPreset) {
    let functionName = 'presetDetailsController.exportPdfPreset';
    $log.info(angular.toJson({action: 'function called', functionName: functionName, pdfPreset: pdfPreset}));
    let extension = pdfPreset.type === 'Fast' ? '.fpp' : '.jobproperties';

    if (pdfPreset.predefined) {
      let url = pdfPreset.url.replace('http:', 'https:');
      let linkObject = [{
        url: url,
        fileName: pdfPreset.name + extension
      }];
      fileDownloaderFactory.downloadUrls(linkObject, true);
    } else {
      presetsService.exportPdfPreset(pdfPreset.id).then(preassignedUrl => {
        let linkObject = [{
          url: preassignedUrl,
          fileName: pdfPreset.name + extension
        }];
        fileDownloaderFactory.downloadUrls(linkObject, true);
      }, error => {
        errorDialogOpen.openErrorDialog(error);
      });
    }
  };

  vm.duplicatePdfPreset = function () {
    vm.pdfPresetDuplicateDisabled = true;
    presetsService.duplicatePdfPreset(vm.selectedFastPdfPreset.id).then(duplicatedPdfPreset => {
      if (duplicatedPdfPreset.type === 'Fast') {
        vm.preset.fastPdfPresetId = duplicatedPdfPreset.id;
        vm.selectedFastPdfPreset = duplicatedPdfPreset;
        updatePdfPresetFields();
        vm.isPdfPresetDetailsVisible = true;
        $('.fast-pdf-preset-details .settings').slideDown();
        vm.vdpPresetForm.fastPdfPresetId.$setDirty(true);
      }

      vm.pdfPresetDuplicateDisabled = false;
    }, error => {
      errorDialogOpen.openErrorDialog(error);
    });
  };

  vm.cancelPdfPresetDuplication = function () {
    vm.selectedFastPdfPreset = angular.copy(vm.duplicatedPdfPreset);
    updatePdfPresetFields();
    vm.duplicatedPdfPreset = undefined;
  };

  vm.savePdfPreset = function ($event) {
    let pdfPresetFields = vm.pdfPresetForm.$$controls.reduce((obj, control) => {
      obj[control.$name] = control.$modelValue;
      return obj;
    }, {});

    if (pdfPresetFields.customBleed !== undefined && pdfPresetFields.customBleed === false) {
      pdfPresetFields.bleedSize = -1;
    } else {
      pdfPresetFields.bleedSize = vm.selectedFastPdfPreset.bleedSizeForDisplay;
    }
    if (pdfPresetFields.downsampleVariableImages !== undefined && pdfPresetFields.downsampleVariableImages === false) {
      pdfPresetFields.downsampleVariableImageDPI = 0;
    }

    $mdDialog.show({
      parent: angular.element(document.body),
      targetEvent: $event,
      clickOutsideToClose: false,
      escapeToClose: false,
      template: require('./save-dialog/save-dialog.html'),
      controller: 'saveDialogController',
      bindToController: true,
      controllerAs: 'vm',
      locals: {
        updatedValues: pdfPresetFields,
        saveFunction: presetsService.addPdfPreset
      }
    }).then(function () {
      vm.duplicatedPdfPreset = undefined;
    }, function (error) {
      if (error) {
        errorDialogOpen.openErrorDialog(error);
      }
    });
    vm.pdfPresetForm.$setPristine();
  };

  vm.openNameConventionEditingDialog = function (event) {
    $mdDialog.show({
      parent: angular.element(document.body),
      targetEvent: event,
      clickOutsideToClose: false,
      escapeToClose: false,
      template: require('./name-convension-editor-dialog/nameConventionDialog.html'),
      controller: 'nameConventionDialog',
      bindToController: true,
      controllerAs: 'vm',
      locals: {
        selectedNameConvention: vm.preset.outputNameConvention,
      }
    }).then(function (newNameConvention) {
      if (newNameConvention && newNameConvention !== vm.preset.outputNameConvention) {
        vm.preset.outputNameConvention = newNameConvention;
        vm.vdpPresetForm.outputNameConvention.$setDirty(true);
      }
    }, function (error) {
      if (error) {
        errorDialogOpen.openErrorDialog(error);
      }
    });
  };

  vm.onFastPdfPresetChange = function (fastPdfPresetId) {
    vm.selectedFastPdfPreset = angular.copy(vm.fastPdfPresets.filter(curr => curr.id === fastPdfPresetId)[0]);
    updatePdfPresetFields();
    if (vm.duplicatedPdfPreset) {
      vm.duplicatedPdfPreset = undefined;
    }
  };

  vm.onRichPdfPresetChange = function (richPdfPresetId) {
    vm.selectedRichPdfPreset = vm.richPdfPresets.filter(curr => curr.id === richPdfPresetId)[0];
    updatePdfPresetFields();
  };

  vm.setAsDefault = function (presetEntry, event) {
    let functionName = 'presetsListController.setAsDefault';
    $log.info(angular.toJson({action: 'function called', functionName: functionName}));

    event.preventDefault();
    event.stopPropagation();

    let confirmMessage = $translate.instant('imposer.composer-main.preset_set_default_confirm', [presetEntry.name]);
    $mdDialog.show({
      parent: angular.element(document.body),
      targetEvent: event,
      clickOutsideToClose: false,
      escapeToClose: true,
      template: require('@printos/imposer-ui/src/components/common/confirm-dialog/confirmDialog.html'),
      controller: 'confirmDialogController',
      bindToController: true,
      controllerAs: 'vm',
      locals: {
        title: 'imposer.composer-main.preset_make_default',
        confirmMessage: confirmMessage,
      }
    }).then(function () {
      presetsService.setAsDefault(presetEntry.id);
      $log.info(angular.toJson({action: 'dialog closed successfully', functionName: functionName}));
    });
  };

  vm.useExternalImpositionOnChange = function(){
    vm.vdpPresetForm.impositionTemplate.$setDirty();
  };

  function deletePdfPreset(pdfPresetIds) {
    let functionName = 'presetDetailsController.deletePdfPreset';
    $log.info(angular.toJson({action: 'function called', functionName: functionName, pdfPresetIds: pdfPresetIds}));

    let defer = $q.defer();
    let pdfPresetId = pdfPresetIds[0];
    presetsService.deletePdfPreset(vm.presetId, pdfPresetId).then(response => {
      defer.resolve(response);
    }, error => {
      defer.reject(error);
    });
    return defer.promise;
  }

  function onPdfPresetEntryAdded(addedEntry) {
    if (addedEntry) {
      if (addedEntry.type === 'Fast') {
        vm.fastPdfPresets.push(addedEntry);
      } else if (addedEntry.type === 'Rich') {
        vm.richPdfPresets.push(addedEntry);
      }
    }
  }

  function onPdfPresetEntryChanged(changedEntry) {
    if (changedEntry) {
      vm.selectedFastPdfPreset = changedEntry;
      updatePdfPresetFields();
      for (let i = 0; i < vm.fastPdfPresets.length; i++) {
        if (vm.fastPdfPresets[i].id === changedEntry.id) {
          vm.fastPdfPresets[i] = changedEntry;
          break;
        }
      }
    }
  }

  function onPdfPresetEntryDeleted(deletedEntry) {
    if (deletedEntry) {
      if (deletedEntry.type === 'Fast') {
        vm.fastPdfPresets = vm.fastPdfPresets.filter(curr => curr.id !== deletedEntry.id);
        if (deletedEntry.id === vm.preset.fastPdfPresetId) {
          vm.selectedFastPdfPreset = angular.copy(vm.fastPdfPresets.filter(curr => curr.default === true)[0]);
          vm.preset.fastPdfPresetId = vm.selectedFastPdfPreset.id;
        }
      } else {
        vm.richPdfPresets = vm.richPdfPresets.filter(curr => curr.id !== deletedEntry.id);
        vm.selectedRichPdfPreset = vm.richPdfPresets.filter(pdfPreset => pdfPreset.default === true)[0];
        vm.preset.richPdfPresetId = vm.selectedRichPdfPreset.id;
      }
    }
  }

  function onPresetEntryChanged(changedEntry) {
    if (changedEntry) {
      let changedEntriesArray;
      if (Array.isArray(changedEntry)) {
        changedEntriesArray = changedEntry;
      } else {
        changedEntriesArray = [changedEntry];
      }
      for (let preset of changedEntriesArray) {
        if (preset && preset.id === vm.preset.id) {
          vm.preset = preset;
          updateFields();
          break;
        }
      }
    }
  }

  function onPresetEntryPdfPresetUnlink(presetsUnlink) {
    if (presetsUnlink && presetsUnlink.presetIds && Array.isArray(presetsUnlink.presetIds)) {
      for (let presetId of presetsUnlink.presetIds) {
        if (presetId === +vm.presetId) {
          if (presetsUnlink.pdfPresetType === 'Fast') {
            vm.selectedFastPdfPreset = vm.fastPdfPresets.filter(pdfPreset => pdfPreset.default === true)[0];
            vm.preset.fastPdfPresetId = vm.selectedFastPdfPreset.id;
            updatePdfPresetFields();
          } else if (presetsUnlink.pdfPresetType === 'Rich') {
            vm.selectedRichPdfPreset = vm.richPdfPresets.filter(pdfPreset => pdfPreset.default === true)[0];
            vm.preset.richPdfPresetId = vm.selectedRichPdfPreset.id;
          }
          break;
        }
      }
    }
  }

  function onIMPPEntryAdded(addedImppEntry) {
    if (addedImppEntry) {
      vm.impositionSelection.impositionTemplatesSelection.push(addedImppEntry);
    }
  }

  function onIMPPEntryDeleted(deletedImppEntries) {
    if (deletedImppEntries) {
      vm.impositionSelection.impositionTemplatesSelection = vm.impositionSelection.impositionTemplatesSelection.filter(imposition => !deletedImppEntries.includes(imposition.templateId));
    }
  }

  $scope.$on('$destroy', function () {
    rnPusher.unbind(vm.channelName, "PDF_PRESET_LIST_ENTRY_ADDED", onPdfPresetEntryAdded);
    rnPusher.unbind(vm.channelName, "PDF_PRESET_LIST_ENTRY_CHANGED", onPdfPresetEntryChanged);
    rnPusher.unbind(vm.channelName, "PDF_PRESET_LIST_ENTRY_DELETED", onPdfPresetEntryDeleted);
    rnPusher.unbind(vm.channelName, "PRESET_LIST_ENTRY_CHANGED", onPresetEntryChanged);
    rnPusher.unbind(vm.channelName, "PRESET_ENTRY_PDF_PRESET_UNLINK", onPresetEntryPdfPresetUnlink);
    rnPusher.unbind(vm.channelName, "IMPP_LIST_ENTRY_ADDED", onIMPPEntryAdded);
    rnPusher.unbind(vm.channelName, "IMPP_LIST_ENTRY_DELETED", onIMPPEntryDeleted);
  });
}
